import {ApDynformsConfigFieldset}                 from '../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                 from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                 from '../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynformsConfigNumerictextbox
}                                                 from '../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {distinctUntilChanged, filter, map}        from 'rxjs/operators';
import {ApDynformsValidator}                      from '../../../ap-dynforms/ap-dynforms-validator';
import {Validators}                               from '@angular/forms';
import {Observable}                               from 'rxjs';
import {Injectable}                               from '@angular/core';
import {
  ApDynGridGroupColumnConfig
}                                                 from '../../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {GetRoundNumericPipe}                      from '../../../ap-utils';
import {ApTranslationService}                     from '../../../ap-utils/service/ap-translation.service';
import {NAppSettingsConfigBase}                   from './base/n-app-settings-config.base';
import {
  NFertilizationPlantProtectionService
}                                                 from '../../../services/data/n-fertilization-plant-protection.service';
import {INFertilizationPlanFieldToSelectGridItem} from '../types/n-fertilization-planning-entry.types';
import IApplicationSettings = Data.Agronomic.IApplicationSettings;
import IApplicationSettingsParameters = Data.Agronomic.IApplicationSettingsParameters;

@Injectable()
export class TargetMapPerPlanConfig extends NAppSettingsConfigBase {
  private _minAllowed = 0;
  private _maxAllowed = 250;

  constructor(private translateService: ApTranslationService,
              private nFertilizationPlantProtectionService: NFertilizationPlantProtectionService,
              private roundNumericPipe: GetRoundNumericPipe) {
    super();
  }

  public formBuilder(values: any, formValues$: Observable<any>, applicationSettings: IApplicationSettings,
                     isModalField: boolean, applyBlinkEffectOnInit: boolean, diagramTemplateRef?: any): ApDynformsConfigFieldset[] {
    const applyBlinkEffect = !(isModalField || !applyBlinkEffectOnInit);
    const parameters = applicationSettings.Parameter;
    const min$ = formValues$.pipe(
      filter(x => Number.isFinite(x['Minimum']) && x['Minimum'] >= 0),
      map((v) => v['Minimum']),
      distinctUntilChanged()
    );
    const max$ = formValues$.pipe(
      filter(x => Number.isFinite(x['Maximum']) && x['Maximum'] >= 0),
      map((v) => v['Maximum']),
      distinctUntilChanged()
    );
    return [
      new ApDynformsConfigFieldset({
        key: 'Agronomy',
        legend: 'Global__Agronomy',
        useMaxWidth: isModalField,
        before: diagramTemplateRef,
        config: [
          new ApDynformsConfigNumerictextbox({
            key: 'Threshold',
            label: 'Global__Threshold_Percent',
            value: values['Threshold'],
            min: 0,
            max: 100,
            step: 1,
            decimals: 0,
            format: 'n0',
            blinkOnInit: applyBlinkEffect,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: ''})
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'NUptakeAreaWeightedAverage',
            label: 'AvgNUptakeShort',
            infoText: 'NUptakeAreaWeightedAverageInfoText',
            value: values['NUptakeAreaWeightedAverage'],
            format: 'n0',
            informational: true
          }),
          this.generateSlopeControls(parameters, values, applyBlinkEffect)
        ]
      }),
      new ApDynformsConfigFieldset({
        legend: 'Nutrients_Pages_Popups__Amount',
        key: 'Amount',
        useMaxWidth: isModalField,
        config: [
          new ApDynformsConfigNumerictextbox({
            key: 'Amount',
            label: 'N__TargetRate_kg_N_per_ha',
            value: values['Amount'],
            min: min$,
            max: max$,
            step: 1,
            format: 'n0',
            blinkOnInit: applyBlinkEffect,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: ''})
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'Constant',
            label: 'Nutrients__Constant_Amount_kg_N_per_ha',
            value: values['Constant'],
            min: min$,
            max: max$,
            step: 1,
            format: 'n0',
            blinkOnInit: applyBlinkEffect,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: ''})
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'Minimum',
            label: 'Nutrients__Minimum_kg_n_per_ha',
            value: values['Minimum'],
            value$: min$,
            min: 0,
            max: max$,
            step: 1,
            format: 'n0',
            blinkOnInit: applyBlinkEffect,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: ''})
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'Maximum',
            label: 'Nutrients__Maximum_kg_n_per_ha',
            value: values['Maximum'],
            value$: max$,
            min: min$,
            max: 250,
            step: 1,
            format: 'n0',
            blinkOnInit: applyBlinkEffect,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: ''})
            ]
          })
        ],
      })
    ];
  }

  public gridBuilderConfig(modeMode$: Observable<boolean>, appSettingsParameters: IApplicationSettingsParameters = null): ApDynGridColumnConfigBase[] {
    const applicationGroupColumns = [];
    applicationGroupColumns.push(
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Average_Amount',
        field: 'Amount',
        width: 50,
        columnLoading: 'ColumnLoading',
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        filterable: true,
        tooltip: (dataItem) => dataItem['ErrorMessage'],
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Threshold',
        field: 'ThresholdAbs',
        width: 50,
        columnLoading: 'ColumnLoading',
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        filterable: true,
        tooltip: (dataItem) => dataItem['ErrorMessage'],
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      })
    );

    if (appSettingsParameters == null || (appSettingsParameters.slopeShown && appSettingsParameters.slopeType === 'numeric')) {
      applicationGroupColumns.push(
        new ApDynGridPropertyColumnConfig({
          title: 'N__RateSlope',
          field: 'ControlFactor',
          width: 50,
          columnLoading: 'ColumnLoading',
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          filterable: true,
          tooltip: (dataItem) => dataItem['ErrorMessage']
        })
      );
    } else if (appSettingsParameters.slopeShown && appSettingsParameters.slopeType === 'dropDown') {
      applicationGroupColumns.push(
        new ApDynGridPropertyColumnConfig({
          title: 'N__RateSlope',
          field: 'ControlFactorDescription',
          width: 50,
          columnLoading: 'ColumnLoading',
          filterable: true,
          tooltip: (dataItem) => dataItem['ErrorMessage']
        })
      );
    }

    applicationGroupColumns.push(
      new ApDynGridPropertyColumnConfig({
        title: 'Global__RateConst',
        field: 'Constant',
        hide: true,
        width: 50,
        columnLoading: 'ColumnLoading',
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        filterable: true,
        tooltip: (dataItem) => dataItem['ErrorMessage'],
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Min',
        field: 'Minimum',
        hide: true,
        width: 50,
        columnLoading: 'ColumnLoading',
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        filterable: true,
        tooltip: (dataItem) => dataItem['ErrorMessage'],
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Max',
        field: 'Maximum',
        hide: true,
        width: 50,
        columnLoading: 'ColumnLoading',
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        filterable: true,
        tooltip: (dataItem) => dataItem['ErrorMessage'],
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
    );
    const applicationHalfViewGroupColumns = [];
    applicationHalfViewGroupColumns.push(
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Threshold',
        field: 'ThresholdAbs',
        width: 50,
        hide: new ApDynGridColumnHideConfig({
          selfHide: modeMode$
        }),
        columnLoading: 'ColumnLoading',
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        filterable: true,
        tooltip: (dataItem) => dataItem['ErrorMessage'],
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
    );

    if (appSettingsParameters == null || (appSettingsParameters.slopeShown && appSettingsParameters.slopeType === 'numeric')) {
      applicationHalfViewGroupColumns.push(
        new ApDynGridPropertyColumnConfig({
          title: 'N__RateSlope',
          field: 'ControlFactor',
          width: 50,
          columnLoading: 'ColumnLoading',
          hide: new ApDynGridColumnHideConfig({
            selfHide: modeMode$
          }),
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          filterable: true,
          tooltip: (dataItem) => dataItem['ErrorMessage']
        })
      );
    } else if (appSettingsParameters.slopeShown && appSettingsParameters.slopeType === 'dropDown') {
      applicationHalfViewGroupColumns.push(
        new ApDynGridPropertyColumnConfig({
          title: 'N__RateSlope',
          field: 'ControlFactorDescription',
          hide: new ApDynGridColumnHideConfig({
            selfHide: modeMode$
          }),
          width: 50,
          columnLoading: 'ColumnLoading',
          filterable: true,
          tooltip: (dataItem) => dataItem['ErrorMessage']
        })
      );
    }
    const configNameTranslation = this.translateService.translate('Global__AppFile');
    const unitTranslation = this.translateService.translate('Nutrients__kg_N_per_ha');
    return [
      new ApDynGridPropertyColumnConfig({
        title: 'AvgNUptakeShort',
        field: 'AvgNUptake',
        headerExtraLines: [
          'Nutrients__kg_N_per_ha'
        ],
        width: 80,
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        filterable: true,
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
      new ApDynGridGroupColumnConfig({
        title: `${configNameTranslation} ${unitTranslation}`,
        hide: true,
        groupColumns: applicationGroupColumns
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Average_Amount',
        field: 'Amount',
        width: 50,
        hide: new ApDynGridColumnHideConfig({
          selfHide: modeMode$
        }),
        columnLoading: 'ColumnLoading',
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        filterable: true,
        tooltip: (dataItem) => dataItem['ErrorMessage'],
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
      new ApDynGridGroupColumnConfig({
        groupColumns: applicationHalfViewGroupColumns
      })
    ];
  }

  public updateFormValuesByParameters(values: any, selectedItems: INFertilizationPlanFieldToSelectGridItem[],
                                      applicationSettings: IApplicationSettings | undefined): void {
    const parameters = applicationSettings.Parameter;
    if (!Number.isFinite(values['Threshold'])) {
      values['Threshold'] = 20;
    }
    if (!Number.isFinite(values['DeadBioMass']) && Number.isFinite(parameters?.deadBioMass)) {
      values['DeadBioMass'] = parameters.deadBioMass;
    } else {
      values['DeadBioMass'] = 0;
    }
    if (!Number.isFinite(values['Amount'])) {
      values['Amount'] = parameters?.targetValue ?? parameters.recommendation;
    }
    if (!Number.isFinite(values['Constant'])) {
      values['Constant'] = parameters?.uniform;
    }
    if (!Number.isFinite(values['Minimum'])) {
      values['Minimum'] = parameters?.min ?? this._minAllowed;
    }
    if (!Number.isFinite(values['Maximum'])) {
      values['Maximum'] = parameters?.max ?? this._maxAllowed;
    }
    if (!Number.isFinite(values['ControlFactor'])) {
      values['ControlFactor'] = parameters?.slope?.FirstOrDefault()?.Slope ?? 1;
    }
    values['NUptakeAreaWeightedAverage'] = this.nFertilizationPlantProtectionService.calculateAreaWeightedAverageOfScans(
      selectedItems, applicationSettings
    );
  }
}
